export default __webpack_public_path__ + "static/media/KishorVaity.91a54fd8.png";